export const engagementPortalRouteBuilders = (portalSlug: string) => ({
  home: `${portalSlug}`,
  reportsIndex: `/${portalSlug}/reports`,
  dashboardsIndex: `/${portalSlug}/dashboards`,
  scorecardsIndex: `/${portalSlug}/kpi-lists`,
  targetManagerShow: (dataset: string) => `/${portalSlug}/targets/${dataset}`,
  users: (portal: EngagementPortal) => {
    if (portal.entityLinks.length > 0) {
      return `/${portalSlug}/access/users/${portal.entityLinks[0].entityId}/${portal.entityLinks[0].entityAppId}`;
    }
    return `/${portalSlug}/access/users/managers`;
  },
});
